<div class="mfr-row">

  <!-- ── Field selector ──────────────────────────────────────────────────── -->
  <p-dropdown
    [options]="groupedFields"
    [(ngModel)]="field"
    [group]="true"
    optionGroupLabel="label"
    optionGroupChildren="items"
    optionLabel="label"
    placeholder="Field…"
    [showClear]="false"
    styleClass="mfr-field-dropdown"
    [pTooltip]="field?.description ?? 'Select a metadata field'"
    tooltipPosition="top"
    (onChange)="onFieldChange()"
  ></p-dropdown>

  <!-- ── Operator selector ────────────────────────────────────────────────── -->
  <p-dropdown
    [options]="availableOperators"
    [(ngModel)]="operator"
    optionLabel="label"
    optionValue="value"
    placeholder="Op"
    [disabled]="!field"
    styleClass="mfr-op-dropdown"
    [pTooltip]="selectedOperatorTooltip"
    tooltipPosition="top"
    (onChange)="onOperatorChange()"
  ></p-dropdown>

  <!-- ── Value 1 ──────────────────────────────────────────────────────────── -->
  <ng-container *ngIf="field" [ngSwitch]="field.fieldType">

    <p-inputNumber
      *ngSwitchCase="FieldType.NUMERIC"
      [(ngModel)]="value"
      [useGrouping]="false"
      [minFractionDigits]="0"
      [maxFractionDigits]="6"
      placeholder="Value"
      styleClass="mfr-value-input"
      [disabled]="!operator"
      (onBlur)="onValueChange()"
    ></p-inputNumber>

    <p-calendar
      *ngSwitchCase="FieldType.DATE"
      [(ngModel)]="value"
      [showTime]="true"
      hourFormat="24"
      dateFormat="yy-mm-dd"
      placeholder="Date & time"
      styleClass="mfr-value-input mfr-calendar"
      [showIcon]="true"
      [disabled]="!operator"
      appendTo="body"
      (onSelect)="onValueChange()"
      (onBlur)="onValueChange()"
    ></p-calendar>

    <input
      *ngSwitchDefault
      pInputText
      [(ngModel)]="value"
      placeholder="Value"
      class="mfr-value-input mfr-text-input"
      [disabled]="!operator"
      (blur)="onValueChange()"
    />

  </ng-container>

  <!-- ── BETWEEN: separator + value 2 ─────────────────────────────────────── -->
  <ng-container *ngIf="isBetween && field">
    <span class="mfr-between-sep">–</span>

    <ng-container [ngSwitch]="field.fieldType">

      <p-inputNumber
        *ngSwitchCase="FieldType.NUMERIC"
        [(ngModel)]="value2"
        [useGrouping]="false"
        [minFractionDigits]="0"
        [maxFractionDigits]="6"
        placeholder="Value"
        styleClass="mfr-value-input"
        (onBlur)="onValue2Change()"
      ></p-inputNumber>

      <p-calendar
        *ngSwitchCase="FieldType.DATE"
        [(ngModel)]="value2"
        [showTime]="true"
        hourFormat="24"
        dateFormat="yy-mm-dd"
        placeholder="Date & time"
        styleClass="mfr-value-input mfr-calendar"
        [showIcon]="true"
        appendTo="body"
        (onSelect)="onValue2Change()"
        (onBlur)="onValue2Change()"
      ></p-calendar>

      <input
        *ngSwitchDefault
        pInputText
        [(ngModel)]="value2"
        placeholder="Value"
        class="mfr-value-input mfr-text-input"
        (blur)="onValue2Change()"
      />

    </ng-container>
  </ng-container>

  <!-- ── Remove button ─────────────────────────────────────────────────────── -->
  <button
    pButton
    icon="pi pi-trash"
    class="p-button-text p-button-danger p-button-sm mfr-remove-btn"
    pTooltip="Remove this filter"
    tooltipPosition="top"
    (click)="remove.emit()"
  ></button>

</div>
